import { CollectionData } from "./collections";
import { getCollectionImageUrl } from "@/lib/cloudinary";

export const darkGreyDescriptionParagraphs = [
  "La collection Dark Grey incarne le mariage ultime entre mystère et élégance. Chaque pièce de cette collection joue avec les contrastes du noir profond et du blanc lumineux, créant une tension visuelle captivante.",
  "Les coupes classiques sont sublimées par des détails modernes et des matières luxueuses, offrant une allure sophistiquée et intemporelle. Chaque silhouette révèle une histoire de pouvoir et de délicatesse.",
  "Cette collection se positionne comme un hommage à l'élégance audacieuse, transformant des inspirations intemporelles en pièces avant-gardistes, parfaitement adaptées à une femme ou un homme sûr(e) de soi et de son style.",
];

export const darkGreyCollection: CollectionData = {
  id: "2021-dark-grey",
  title: "Collection Dark Grey",
  descriptionParagraphs: darkGreyDescriptionParagraphs,
  images: [
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-01"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-02"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-03"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-04"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-05"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-06"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-07"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-08"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-09"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-10"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-11"),
    getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-12"),
  ],
  date: "11/21",
  bannerImage: getCollectionImageUrl("2021-dark-grey", "ALEXANDRA-GREY-DARK-GREY-01"),
};
